"use client";

import { getStrapiMedia } from "@/utils/api-helpers";
import { memo } from "react";

type VidProps = { src: string; fallback: string; className: string };

const MemoVidPlayer = memo(({ src, fallback, className }: VidProps) => {
    return (
        <video muted loop playsInline autoPlay className={className}>
            <source src={getStrapiMedia(src)} type="video/webm"></source>
            {fallback.length > 0 && (
                <source src={getStrapiMedia(src)} type="video/mp4"></source>
            )}
        </video>
    );
});
MemoVidPlayer.displayName = "MemoVidPlayer";

export const LazyLoadVid = ({ src, fallback, className }: VidProps) => {
    
    return (
        <div className="reveal-anim">
            <MemoVidPlayer
                src={src}
                fallback={fallback}
                className={className}
            />
        </div>
    );
};
